<template>
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00024 4.07541C8.00024 4.45277 7.69836 4.75466 7.321 4.75466H4.60402V7.32069C4.60402 7.69805 4.30213 7.99994 3.92477 7.99994C3.54741 7.99994 3.24553 7.69805 3.24553 7.32069V4.75466H0.679489C0.302131 4.75466 0.000244141 4.45277 0.000244141 4.07541C0.000244141 3.69805 0.302131 3.39617 0.679489 3.39617H3.24553V0.679184C3.24553 0.301826 3.54741 -6.10352e-05 3.92477 -6.10352e-05C4.30213 -6.10352e-05 4.60402 0.301826 4.60402 0.679184V3.39617H7.321C7.69836 3.39617 8.00024 3.69805 8.00024 4.07541Z" :fill="fill"/>
  </svg>
</template>


<script>
export default {
  name: 'plusSmallIcon',
  props: {
    fill: {
      type: String,
      default: 'white'
    }
  }
}
</script>

<style lang="scss" scoped>
.add-project {
  path {
    fill: $lightBlue;
  };

  &:hover {
    path {
      fill: white
    }
  }
}
</style>
